import { HttpBadStatusCodeError } from '@cian/peperrors/shared';

import {
  fetchUpdateUserReplyTemplate,
  type TUpdateUserReplyTemplateResponse,
  type TUpdateUserReplyTemplateRequest,
} from '../../repositories/chats/v1/update-user-reply-template';

import type { IApplicationContext } from '../../types/applicationContext';
import type { FetchResponse } from '@cian/http-api';

export async function updateUserReplyTemplatePublic(
  context: IApplicationContext,
  parameters: TUpdateUserReplyTemplateRequest,
) {
  const { httpApi, logger } = context;

  try {
    const { response, statusCode }: FetchResponse<TUpdateUserReplyTemplateResponse> =
      await fetchUpdateUserReplyTemplate({
        httpApi,
        parameters,
      });

    if (statusCode !== 200) {
      throw new HttpBadStatusCodeError(response.message || '', statusCode);
    }

    return response;
  } catch (e) {
    logger.error(e, {
      description: 'Ошибка обновления шаблона ответа',
    });

    throw e;
  }
}
